export default "__VITE_ASSET__476439a8__"